export enum MessageStatus {
  success = "success",
  info = "info",
  warning = "warning",
  error = "error"
}

export interface WorkspaceState {
  readonly message?: string;
  readonly status?: MessageStatus;
}
